import { useMutation } from '@tanstack/react-query';
import { GRANT_TYPE, CLIENT_ID, CLIENT_SECRET } from '@/config';
import {
  CUSTOMER_LOGIN,
  CUSTOMER_LOGIN_WITH_MOBILE_OTP,
  CUSTOMER_LOGIN_WITH_OTP,
  CUSTOMER_VERIFY_OTP,
} from '@/constants/API';
import { axios } from '@/lib/axios';
import { setStoreAuthResult } from '@/services/auth';
import {
  IStoredAuth,
  LoginCredentialsDTO,
  LoginWithMobileOTPCredentialsDTO,
  LoginWithMobileOTPResponse,
  LoginWithOTPCredentialsDTO,
  LoginWithOTPResponse,
} from '@/types/auth';
import { Company } from '@/types/company';
import storage from '@/utils/storage';

export const loginWithUsernameAndPassword = async (payload: LoginCredentialsDTO) => {
  // const cartRef = storage.getItem('cartRef');
  payload.grant_type = GRANT_TYPE;
  payload.client_id = CLIENT_ID;
  payload.client_secret = CLIENT_SECRET;
  payload.company_id = storage.getItem('company')?.id;
  // payload.cartRef = cartRef ?? null;
  return await axios.post(CUSTOMER_LOGIN, payload);
};

export const loginWithOTPMethod = async (payload: LoginWithOTPCredentialsDTO) =>
  await axios.post<LoginWithOTPResponse>(CUSTOMER_LOGIN_WITH_OTP, payload);

export const loginWithMobileOTPMethod = async (payload: LoginWithMobileOTPCredentialsDTO) =>
  await axios.post<LoginWithMobileOTPResponse>(CUSTOMER_LOGIN_WITH_MOBILE_OTP, payload);

export const loginVerifyOTP = async (payload: LoginWithOTPCredentialsDTO & { otp: string }) =>
  await axios.post<{ valid: boolean }>(CUSTOMER_VERIFY_OTP, payload);

export const ssoLogin = () => {
  const company: Company = storage.getItem('company');
  window.open(`/api/sso/redirect/${company.id}`, '_parent');
  // window.open(`https://namma.rc.hungerbox.com/api/sso/redirect/114`, '_parent');
};

export const useLoginMutation = () =>
  useMutation(loginWithUsernameAndPassword, {
    onSuccess: async (data: any) => {
      const authData: IStoredAuth = {
        webAccessToken: data.access_token,
        refreshToken: data.refresh_token,
        expiresIn: data.expires_in,
        scope: data.scope,
      };
      setStoreAuthResult(authData);
    },
  });

export const useLoginWithOTPMutation = () => useMutation(loginWithOTPMethod);

export const useLoginWithMobileOTPMutation = () => useMutation(loginWithMobileOTPMethod);

export const useLoginVerifyOTPMutation = () => useMutation(loginVerifyOTP);
